<script>

import { onMount, setContext } from "svelte";
import TableFooter from "../../../Components/Layout/Table/TableFooter.svelte";
import SvelteTable from "../../../Components/Common/SvelteTable.svelte";
import { getText, goToURL, showError } from "../../../Utils/utilFunctions.svelte";
    import { apiMethods } from "../../../Services/index.svelte";
    import MBSItemDescription from "../../MBSItems/MBSItemDescription.svelte";
    import SearchInput from "../../../Components/Common/SearchInput.svelte";
    import SearchSelect from "../../../Components/Common/SearchSelect.svelte";
    import filter from "svelte-select/filter";

export let noGapProgramDetails;

let isLoadingRebates = false,
    isLoadingRebateTables = false,
    itemsNoGapRebates = [],
    rebateTablesOptionsArr = [],
    page = 0,
    pageSize = 25,
    count = 0,
    filters = {
      itemNum: null,
      hospitalIds: [],
      insuranceFundsIds: [],
      rebateTable: null
    };

onMount(() => {
    //set the filters from the selected no gap program
    if(noGapProgramDetails.hospitalId) {
        filters = {
            ...filters,
            hospitalIds: [noGapProgramDetails.hospitalId]
        }
    }

    if(noGapProgramDetails.fundId) {
        filters = {
            ...filters,
            insuranceFundsIds: [noGapProgramDetails.fundId]
        }
    }
    loadNoGapProgramRebatesTableNames(true);

    loadNoGapProgramRebates(true); //with loading
    
});

const loadNoGapProgramRebatesTableNames = async (withLoading = false) => {
    try {
        var getfilters = {
        };
        if(filters.hospitalIds.length) {
            getfilters = {
                ...getfilters,
                "filter[hospitalid]": filters.hospitalIds.join(",")
            };
        }
        if(filters.insuranceFundsIds.length) {
            getfilters = {
                ...getfilters,
                "filter[fundid]": filters.insuranceFundsIds.join(",")
            }
        }
        if(withLoading)
            isLoadingRebateTables = true;
        var tableNames =  await apiMethods.getMethod.getNoGapProgramRebatesTablesName(
            page * pageSize, 
            pageSize,
            getfilters
        );
        if(tableNames)
            rebateTablesOptionsArr = tableNames;
        isLoadingRebateTables = false;
    }
    catch(err) {
        showError(err ?? "There was an error trying to fetch the no gap rebates tables. Please refresh the page and try again, or contact support for asistance.")
    }
}

const loadNoGapProgramRebates = async (withLoading = false) => {
    try {
        var getfilters = {
            "filter[itemNum]": filters.itemNum ?? "*"
        };
        if(filters.rebateTable) {
            getfilters = {
                ...getfilters,
                "filter[tablename]": filters.rebateTable
            }
        }
        if(filters.hospitalIds.length) {
            getfilters = {
                ...getfilters,
                "filter[hospitalid]": filters.hospitalIds.join(",")
            };
        }
        if(filters.insuranceFundsIds.length) {
            getfilters = {
                ...getfilters,
                "filter[fundid]": filters.insuranceFundsIds.join(",")
            }
        }
        if(withLoading)
            isLoadingRebates = true;
        var res =  await apiMethods.getMethod.getNoGapProgramRebates(
            page * pageSize, 
            pageSize,
            getfilters
        );
        if (!res || res.error)
            showError(
                "Failed to load no gap rebates, please refresh the page and try again and contact support if the issue persists.",
            );
        else {
            itemsNoGapRebates = res.results;
            count = res.total;
        }
        isLoadingRebates = false;
    }
    catch(err) {
        showError(err ?? "There was an error trying to fetch the no gap rebates. Please refresh the page and try again, or contact support for asistance.")
    }
}

const noGapRebatesColumns = [
    {
        key: "tableNameKey",
        title: "Table Name",
        headerClass: "text-left pl-3 font-bold",
        class: "text-left px-3 text-left truncate",
        value: (v) => v.name ? getText(v.name) : "Default",
    },
    {
        key: "itemNumKey",
        title: "Item Num",
        headerClass: "text-left pl-3 font-bold",
        class: "text-left px-3 text-left truncate",
        value: (v) => getText(v.itemNum),
    },
    {
      key: "itemDescription",
      title: "Description",
      headerClass: "text-left pl-3 font-bold",
      class: "text-left px-3 text-left max-w-[500px] truncate",
      value: (v) => `<div class="truncate cursor-pointer" title='${getText(v.itemDescription)}'>${getText(v.itemDescription)}</div>`,
    },
    {
        key: "rebateKey",
        title: "Rebate",
        headerClass: "text-left pl-3 font-bold w-[120px]",
        class: "text-left px-3 text-left w-[120px] truncate",
        value: (v) => `<div class="truncate cursor-pointer">$${formatRebateValue(v.rebate)}</div>`,
    }
];

const formatRebateValue = (v) => {
    if (v === null || v === undefined) return '';

    if (typeof v === 'number') {
        return v.toFixed(2);
    }

    return String(v);
};

const handleClickCell = (
    { target: { className, classList } },
    rowData,
    key,
) => {
   
};

const onPageChange = (e) => {
    page = Number(e.detail.page);

    loadNoGapProgramRebates();
};

const onPageSizeChange = (newPageSize) => {
    pageSize = newPageSize;
    page = 0;

    loadNoGapProgramRebates();
};

const handleFilterRebates = () => {
    //always reset the page
    page = 0;

    loadNoGapProgramRebates();

  };

</script>

<div class="w-full flex flex-col gap-y-2 h-[600px]">
    <div class="p-2 flex flex-row gap-2">
        <SearchSelect
            bind:value={filters.rebateTable}
            title="Table Name"
            onChangeFunc={handleFilterRebates}
            isDisabled={isLoadingRebateTables}
            inputClass="w-[300px] !bg-white"
        >
            <option value="" selected>
                All tables
            </option>
            {#each rebateTablesOptionsArr as table}
                <option value={table}>{table}</option>
            {/each}
        </SearchSelect>
        <SearchInput
            bind:value={filters.itemNum}
            title="Item Number"
            placeholder=""
            inputClass="!w-full bg-transparent hover:bg-transparent"
            inputFunc={handleFilterRebates}
            isLong
        />
    </div>
    <div class="flex flex-1 overflow-scroll">
        {#if itemsNoGapRebates.length}
            <SvelteTable 
                columns={noGapRebatesColumns} 
                rows={itemsNoGapRebates}
                clickCellFunc={({ detail: { event, row, key } }) => {
                    handleClickCell(event, row, key);
                }}
            />
        {:else}
            <div class="grid flex-1 h-full card bg-white rounded-box">
            <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row p-2">
                <p>No Gap Rebates were not found </p>
            </div>
            </div>
        {/if}
    </div>
    <div class="p-2">
        <TableFooter
            {page}
            {pageSize}
            {count}
            showSelected
            selectedCount={itemsNoGapRebates.length}
            tableData={itemsNoGapRebates}
            {onPageChange}
            {onPageSizeChange}
        />
    </div>
</div>


